import React,{useState} from "react";
import classes from "./ClinicCard.module.css";

//components
import AnimatedCard from "../../../UI/AnimatedCard/AnimatedCard";
import Button from "../../../UI/Button/Button";
import Modal from "../../../UI/Modal/Modal"
import AppointmentForm from "./AppointmentForm/AppointmentForm";

const ClinicCard = (props) => {
  const [isVisible,setIsVisible] = useState(false)
  const [doctor,setDoctor] = useState("")

  const cancel = () =>{
    setIsVisible(false);
  }
  const openModal = (event) =>{
    setDoctor(event.target.innerText)
    setIsVisible(true)
  }
  return (
    <AnimatedCard className={classes.container}>
      {isVisible && <Modal cancel={cancel} title="احجز موعد" circle={2500} mobile={true}>
          <AppointmentForm doctor={doctor} clinic={props.Clinic.ServName}/>
        </Modal>}
      <div>
        <h1>{props.Clinic.ServName}</h1>
      </div>
      <div className={classes.doctorsSection}>
        
        
          {props.Clinic.Doctors.map((Doctor) => {
            return (
              <Button
                key={Doctor.DocId}
                width={"100"}
                height={"30"}
                onClick={openModal}
              >{Doctor.DocName}</Button>
            );
          })}
        
         
      </div>
    </AnimatedCard>
  );
};
export default ClinicCard;
